import { createGlobalStyle } from "styled-components";

export default createGlobalStyle`
  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    font-family: "Inter", sans-serif;
  }
  body {
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    ${({ theme }) =>
      theme === "dark"
        ? `    
        background: radial-gradient(circle, rgba(10,42,88,1) 50%, rgba(1,16,37,1) 100%) center center / cover no-repeat fixed;
    `
        : `
      background: #ffffff;
    `};
  }
  #background-radial-gradient {
    ${({ theme }) =>
      theme !== "dark" &&
      `
      background: radial-gradient(50% 50% at 50% 50%, rgba(33, 114, 229, 0.3) 0%, rgb(70 132 167 / 0%) 100%);
    `};
    transition: all 0.3s ease-in-out;
  }
  #root {
    height: 100vh;
    width: 100%;
    > div:first-child {
      margin-top: ${({ thereIsNavbar }) => thereIsNavbar ? "6rem" : ""};
    }
    > div:not(#kt_header):not(#kt_header_mobile) {
      min-height: ${({ thereIsNavbar }) =>
        thereIsNavbar ? "calc(100vh - 80px)" : "100vh"};
      display: flex;
      flex-direction: column;
      justify-content: space-around;
      gap: 1rem;
    }
  }
  .center-absolute {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .vi__character {
    border: 0 !important;
    background: #07214666 !important;
    border-bottom: 1px solid rgb(255 255 255) !important;
    color: #ffff !important;
  }
  .gap-1 {
    gap: 1rem;
  }
  .symbol.symbol-40 > img {
    min-width: 40px;
  }
  .wizard {
    .vi__container {
      .vi__character {
        border: 0 !important;
        background: transparent !important;
        border-bottom: 1px solid rgba(20, 20, 20, 0.1) !important;
        color: unset !important;
      }
    }
    > .steps > ul li .title {
      display: block;
    }
    .steps .done a .title,
    .steps .done a:active .title,
    .steps .done a:hover .title {
      display: block;
    }
    .number {
      cursor: pointer;
    }
  }
  .css-ovthrp {
    svg {
      width: 24px;
      height: 24px;
    }
  }
  .disabled {
    cursor: default;
    pointer-events: none;
  }
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .logo-default {
    fill: #002c74;
  }
  .header-menu .menu-nav > .menu-item > .menu-link {
    height: 100%;
  }
  .btn.btn-primary-custom, a.text-hover-primary, .text-hover-primary {
    transition: all 0.3s ease-in-out;
  }
  .btn-theme-changer {
    padding: 0.6rem 1rem;
    cursor: pointer;
    border-radius: 1rem;
    transition: all 0.3s ease-in-out;
    color: #8695a7 !important;
    height: 100%;
    path {
      fill: #8695a7 !important;
    }
  }
  .addres-info {
    display: flex;
    align-items: center;
    gap: 1rem;
    > span:first-child {
      min-width: 120px;
      text-align: center;
    }
    button {
      border: 0;
      background: transparent;
      display: flex;
      align-items: center;
      gap: 1rem;
      border-radius: 1rem;
      font-weight: bold;
      padding: 0.6rem 1rem;
      color: #3F4254;
      border: 2px solid #3F4254;
      transition: all 0.3s;
      :hover {
        background: #3F4254;
        color: #fff;
        transition: all 0.3s;
      }
    }
  }
  .status-div.wallet-error {
    background: #ef182e21 !important;
    .text-white {
      color: #000 !important;
    }
  }
  .text-warning-des {
    color: #3F4254;
  }
  .bg-light-succsess {
    .bg-light-succsess__link {
      color: #1bc5bd;
      font-weight: bold;
      text-decoration: underline;
    }
  }
  .walletconnect-modal__mobile__toggle{
    display: none !important;
  }
  .walletconnect-modal__footer {
    margin-top: 10px !important;
  }
  .walletconnect-qrcode__text {
    margin-bottom: 10px !important;
  }
  .dark-mode {
    color: #fff;
    hr {
      border-color: #1d458059!important;
    }
    .btn.btn-hover-transparent-dark {
      :hover .svg-icon svg g [fill], :focus .svg-icon svg g [fill], .svg-icon svg g [fill] {
        fill: #ffffff !important;
      }
    }
    .burger-icon span::before, .burger-icon span::after, #kt_header_mobile_toggle span {
      background-color: rgb(255 255 255);
    }

    .header-mobile .burger-icon span::before, .header-mobile .burger-icon span::after {
      background-color: rgb(255 255 255);
    }

    .bg-light-succsess {
      svg {
        height: 12.75rem !important;
        width: 12.75rem !important;
        position: absolute;
        top: -38px;
        right: 4%;
        transform: rotate(1deg);
        opacity: .5;
      }
    }
    .bg-light-succsess {
      background-color: #1bc5bd2e !important;
    }
    .text-warning-des {
      color: #fff;
    }
    .logo-default {
      fill: #ffffff;
    }
    .status-div.wallet-error {
      background:  #ff001a45 !important;
      .text-white {
        color: #fff !important;
      }
    }
    .addres-info {
      button {
        color: #fff;
        border: 2px solid #fff;
        transition: all 0.3s;
        :hover {
          background: #6993FF;
          border-color: #6993FF;
          color: #fff;
          transition: all 0.3s;
        }
      }
    }
    .status-div.bg-light-warning .text-white {
      color: #fff !important;
    }
    .bg-light-warning:not(.just-dark) p {
      color: #041632;
    }
    .btn-theme-changer {
      color: #8695a7 !important;
      path {
        fill: #8695a7 !important;
      }
    }
    @media screen and (max-width: 1000px) {
      .header-menu-mobile {
        background-color: #002c74;
      }
      .header-menu-wrapper {
        background: #002c74;
      }
    }
    .header-menu-wrapper-on {
      .menu-link {
        background: #002c74;
      }
      .header-menu-wrapper-on .header-menu-mobile .menu-nav > .menu-item:not(.menu-item-parent):not(.menu-item-open):not(.menu-item-here):not(.menu-item-active):hover > .menu-link {
        background-color: #002c74;
      }
      .menu-item {
        .menu-link:hover {
          background: #002c74 !important;
          background-color: #002c74 !important;
        }
      }
    }
    .card {
      background-color: #ffffffb5;
      background: linear-gradient(156deg, rgb(0 25 65 / 77%) 0, rgb(0 29 77 / 34%) 50%, rgba(0, 36, 93, 0.6250097451089811) 100%);
      background-clip: border-box;
      border: 0;
    }
    .form-control {
      background-color: #041632 !important;
      color: #ffffff;
    }
    .input-group.input-group-solid {
      background-color: #041835;
    }
    .btn.btn-primary {
      color: #fff;
      background-color: #022b66;
      border-color: #022b66;
    }
    .btn.btn-clean path {
      fill: #fff !important;
    }
    .btn:hover:not(.btn-text):not(.just-white):not(.create-ticket-icon) path,
    .btn:focus:not(.btn-text):not(.just-white):not(.create-ticket-icon) path,
    .btn.focus:not(.just-white):not(.create-ticket-icon) path {
      fill: #041835 !important;
    }
    .bg-light-primary {
      background-color: #e1e9ff29 !important;
    }
    .status-div.bg-light-primary {
      background-color: #0050ff2b !important;
    }
    .bg-light-success {
      background-color: #5090ea52 !important;
    }
    .label.label-light-primary {
      color: #022b66;
      background-color: #E1E9FF;
    }
    ul.menu-nav {      
      background-color: rgb(4 24 53);
    }
    .active-item {
      background: linear-gradient(279deg, #142977, #2145d4) !important;
      background-position: 100px;
      transition: all 0.3s ease-in-out;
    }
    .menu-toggle .menu-text {
      color: #fff !important;
    }
    .header-menu .menu-nav > .menu-item:hover:not(.menu-item-here):not(.menu-item-active) > .menu-link,
    .header-menu .menu-nav > .menu-item.menu-item-hover:not(.menu-item-here):not(.menu-item-active) > .menu-link,
    .header-menu .menu-nav > .menu-item.menu-item-here > .menu-link,
    .header-menu .menu-nav > .menu-item.menu-item-active > .menu-link {
      color: rgb(0, 0, 0);
      background: linear-gradient(279deg, #142977, #2145d4);
    }
    .bmxxax {
      background-color: #0d1a46;
      color: #62b2eb;
    }
    .btn.btn-white:not(.just-white) {
      background-color: transparent;
      border-color: transparent;
    }
    .btn.btn-mode .svg-icon svg g [fill] {
      fill: #ffffff;
    }
    .btn.btn-white:hover:not(.btn-text):not(:disabled):not(.disabled):not(.just-white),
    .btn.btn-white:focus:not(.btn-text):not(.just-white),
    .btn.btn-white.focus:not(.btn-text):not(.just-white) {
      color: #ffffff !important;
      background-color: #131628 !important;
      border-color: #131628 !important;
    }
    .btn.btn-white:hover:not(.btn-text):not(:disabled):not(.disabled):not(.just-white) .svg-icon svg g [fill],
    .btn.btn-white:focus:not(.btn-text):not(.just-white) .svg-icon svg g [fill],
    .btn.btn-white.focus:not(.btn-text):not(.just-white) .svg-icon svg g [fill] {
      fill: #ffffff !important;
    }
    .modal-content {
      background-color: #05224f;
      background: rgb(0 36 93 / 100%);
    }
    .css-ryy4eq {
      background: #011b46;
    }
    .modal .modal-header .modal-title {
      color: #ffffff;
    }
    .modal-header button {
      color: #ffffff;
    }
    .wizard > .steps .current a, .wizard > .steps .current a:active, .wizard > .steps .current a:hover,
    .wizard > .steps a, .wizard > .steps a:active, .wizard > .steps a:hover {
      color: #ffffff;
    }
    .css-1i0rbqg, .css-ovthrp {
      background: #022b66;
      color: #6993FF;
      border: 1px solid #1f427e;
      :hover {
        color: #ffffff;
      }
    }
    .css-ovthrp {
      svg {
        path {
          fill: white;
        }
      }
    }
    .apple-icon {
      path {
          fill: white;
        }
    }
    .wizard .vi__container .vi__character {
      border-bottom: 1px solid rgb(218 231 251) !important;
    }
    .modal-header {
      border-bottom: 1px solid #1f427e;
    }
    .modal-footer {
      border-top: 1px solid #1f427e;
      button {
        :first-child {
          color: #fff;
          background: linear-gradient(279deg,#142977,#2145d4);
        }
        :last-child {
          background: #ffffff12;
          color: #fff;
        }
      }
    }
    .wizard > .content {
      border-bottom: 1px solid #1f427e;
      border-top: 1px solid #1f427e;
    }
    .border-bottom {
      border-bottom: 1px solid #1d458059!important;
    }
    .border-top {
      border-top: 1px solid #1d458059!important;
    }
    .form-control.form-control-solid {
      background-color: #041835;
      border-color: #042e6b;
      color: #eee;
    }
    .card-header {
      border-bottom: 1px solid #0f3369;
    }
    .card-footer {
      border-top: 1px solid #0f3369;
    }
    .image-input.image-input-outline .image-input-wrapper {
      border-color: #041835;
    }
    .form-group label {
      color: #b1b1bf;
    }
    .btn.btn-light-primary {
      background-color: rgb(65 122 201 / 35%);
    }
    .input-group.input-group-solid .form-control.form-control-solid:active, .input-group.input-group-solid .form-control.form-control-solid.active, .input-group.input-group-solid .form-control.form-control-solid:focus, .input-group.input-group-solid .form-control.form-control-solid.focus {
      background-color: #041835;
      border-color: #EBEDF3;
      color: #fff;
    }
    .text-dark {
      color: #fff !important;
    }
    .bg-custom {
      background: #041835;
    }
    .btn.btn-primary-custom {
      background: linear-gradient(279deg, #142977, #2145d4);
      border: 0;
      transition: all 0.3s ease-in-out;
      :hover {
        background: linear-gradient(102deg, #142977, #2145d4);
        transition: all 0.3s ease-in-out;
      }
    }
    .bg-custom-purchase {
      background: #041835;
    }
    .lgdLLT {
      background-color: rgb(4 48 112);
      color: #fff;
      border: 0;.btn.btn-primary-custom
    }
    .bg-progress-custom {
      background-color: #2043cd !important;
    }
    .loading-icon, .loading-row {
      background: #ffffff0f;
    }
    .border-dark {
      border-color: #0a2f6a !important;
    }
    .create-ticket-icon {
      background-color: #041632 !important;
      border: 0 !important;
    }
    .create-ticket-icon:hover svg path {
      fill: #fff !important;
    }
    .create-ticket-icon:focus {
      border: 1px solid #fff !important;
      svg path {
        fill: #fff !important;
      }
    }
    .progress.progress-xs {
      background: #041835;
    }
  }
  #Disclaimer {
    > div:first-child {
      outline: 2px solid #ffffff;
      border-radius: 8px;
      overflow: hidden;
      > div {
        overflow: auto;
        max-height: 500px;
        padding: 1.5rem;
      }
    }
    ol {
      counter-reset: section;
      list-style-type: none;
      ol {
        padding-inline-start: 1rem;
      }

      li {
        :not(:first-child){
          margin-top: 1rem
        }
        ::before {
          counter-increment: section;
          content: counters(section, ".") "  ";
        }
      }
    }
  }
`;
